import { z } from 'zod';

import { Current } from './Current';

export const ShortCircuitCurrent = {
    validator: Current.validators.value,
    units: Current.units,
};

export type ShortCircuitCurrent = z.infer<typeof ShortCircuitCurrent.validator>;
